<section id="app" class="section-padding">
  <div class="container">
    <div class="row">
      <div class="col-md-5 offset-md-1 col-sm-6 ">
        <div class="sub-title"><span class="red">CAR</span>DATA</div>
        <div class="app-title">
          Cardata Mobil, Yeni Özellikleri ve Yenilenen Altyapısıyla <br />
          Şimdi Çok Daha Güçlü !
        </div>
        <div class="app-desc">
          <i class="fa fa-angle-double-right"></i> Güncel 2. El değeri hesapla<br />
          <i class="fa fa-angle-double-right"></i> Tüm 0 Km araçlar tek ekranda<br />
          <i class="fa fa-angle-double-right"></i> Araç bilgisini detaylı tanımla<br />
          <i class="fa fa-angle-double-right"></i> Araçları tek ekranda karşılaştır<br />
          <i class="fa fa-angle-double-right"></i> Doğru fiyatla güvenle karar ver
        </div>
        <div class="apps-store">
          <a href="https://play.google.com/store/apps/details?id=com.cardata&hl=tr" target="_blank">
            <img src="assets/img/shared/storegoogle.png" alt="Google Play">
          </a>
          <a href="https://apps.apple.com/tr/app/cardata/id1187720629" target="_blank">
            <img src="assets/img/shared/storeapple.png" alt="App Store">
          </a>
        </div>
      </div>
      <div class="col-md-5 col-sm-6">
        <img class="app-screen" src="assets/img/shared/mobile-app-banner.webp" alt="Cardata Mobil">
      </div>
    </div>
  </div>
</section>
